import { createContext, useState, useEffect } from "react";
import axios from "axios";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const fetchUser = async () => {
    const storedUser = localStorage.getItem("user");
    if (!storedUser) return;

    try {
      const parsedUser = JSON.parse(storedUser);
      if (!parsedUser?._id) return;

      const { data: newUserData } = await axios.post(`/api/users`, { _id: parsedUser._id });
      const updatedUser = { ...parsedUser, ...newUserData };

      if (JSON.stringify(updatedUser) !== JSON.stringify(parsedUser)) {
        localStorage.setItem("user", JSON.stringify(updatedUser));
        setUser(updatedUser);
      }
    } catch (error) {
      console.error("Erro ao buscar dados do usuário:", error);
    }
  };

  useEffect(() => {
    fetchUser();
    const interval = setInterval(fetchUser, 1 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <UserContext.Provider value={{ user, fetchUser }}>
      {children}
    </UserContext.Provider>
  );
};
